import { useGetMealConfiguration } from '@/common/integrations/menhir/employee/meal/meal.hooks';
import { TMealPaymentStrategy } from '@/common/integrations/menhir/employee/meal/meal.types';
import { useGetPockets } from '@/common/integrations/menhir/employee/pockets/pockets.hooks';

export function useCurrentMealPaymentStrategy(): {
  strategy?: TMealPaymentStrategy;
  isLoading: boolean;
} {
  const { mealConfiguration, isInitialLoading: isMealConfigurationLoading } =
    useGetMealConfiguration();
  const { creditsPocket, isInitialLoading: isCreditsPocketLoading } =
    useGetPockets();

  const isSinglePaymentEnabled = !!mealConfiguration?.singleTransaction;
  const isCreditsPaymentEnabled = !!creditsPocket?.balance;

  if (isMealConfigurationLoading || isCreditsPocketLoading) {
    return {
      isLoading: true,
    };
  }

  if (isSinglePaymentEnabled) {
    return {
      strategy: 'card',
      isLoading: false,
    };
  }

  if (isCreditsPaymentEnabled) {
    return {
      strategy: 'credits',
      isLoading: false,
    };
  }

  return {
    strategy: 'none',
    isLoading: false,
  };
}
